import React from "react"
import "./Carousel.scss"
import { database } from "../../../firebase"
// import img1 from "./images/Carousel_Images/1.jpg"
// import img2 from "./images/Carousel_Images/2.jpg"
// import img3 from "./images/Carousel_Images/3.jpg"
// import img4 from "./images/Carousel_Images/4.jpg"
// import img5 from "./images/Carousel_Images/5.jpg"

function useTilt(active) {
  const ref = React.useRef(null)

  React.useEffect(() => {
    if (!ref.current || !active) {
      return
    }

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined
    }

    const el = ref.current

    const handleMouseMove = (e) => {
      if (!el) {
        return
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect()
      }
      state.mouseX = e.clientX
      state.mouseY = e.clientY
      const px = (state.mouseX - state.rect.left) / state.rect.width
      const py = (state.mouseY - state.rect.top) / state.rect.height

      el.style.setProperty("--px", px)
      el.style.setProperty("--py", py)
    }

    el.addEventListener("mousemove", handleMouseMove)

    return () => {
      el.removeEventListener("mousemove", handleMouseMove)
    }
  }, [active])

  return ref
}

function Slide({ slide, offset }) {
  const active = offset === 0 ? true : null
  const ref = useTilt(active)

  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        "--offset": offset,
        "--dir": offset === 0 ? 0 : offset > 0 ? 1 : -1
      }}
    >
      {/* <div
      className="slideBackground"
      style={{
        backgroundImage: `url('${slide.image}')`
      }}
    /> */}
      <div
        className="slideContent"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      >
        <div className="slideContentInner" />
      </div>
    </div>
  )
}

const Carousel = () => {
  const [slides, setslides] = React.useState([])
  React.useEffect(async () => {
    database.home_carousel
      .orderBy("name", "asc")
      .onSnapshot((querySnapshot) => {
        const arr1 = []
        querySnapshot.forEach((doc) => {
          const { URL } = doc.data()
          arr1.push(URL)
        })
        const slide = []

        for (let i = 0; i < arr1.length; i++) {
          slide.push({ image: arr1[i] })
        }
        setslides(slide)
      })
  }, [])

  const initialState = {
    slideIndex: 0
  }

  const slidesReducer = (state, event) => {
    if (event.type === "NEXT") {
      return {
        ...state,
        slideIndex: (state.slideIndex - 1) % slides.length
      }
    }
    if (event.type === "PREV") {
      return {
        ...state,
        slideIndex: (state.slideIndex + 1) % slides.length
      }
    }
  }

  const [state, dispatch] = React.useReducer(slidesReducer, initialState)

  return (
    <div className="main">
      <div className="slides">
        <button onClick={() => dispatch({ type: "PREV" })}>‹</button>

        {[...slides, ...slides, ...slides].map((slide, i) => {
          const offset = slides.length + (state.slideIndex - i)
          return <Slide slide={slide} offset={offset} key={i} />
        })}
        <button onClick={() => dispatch({ type: "NEXT" })}>›</button>
      </div>
    </div>
  )
}

export default Carousel
